import { useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { Element } from '../../../common/html/element'
import { selectUserType } from '../../../layout/store/slice'
import { TitleComponent } from '../../common/html/TitleComponent'
import { ItemLink } from './ItemLink'
import { selectDataMostPopular } from './store/slice'

export const Popular = () => {
  const data = useSelector(selectDataMostPopular)
  const userType = useSelector(selectUserType)
  const newArr = [...new Array(10)].map((_, index) => data[index])

  return (
    <div className="flexColumn h100">
      <div style={{ paddingBottom: 4 }}>
        <TitleComponent title="dashboard.recentlyAndPopular.titlePopular" />
      </div>
      <div className="flexColumn justifyContentBetween h100">
        {!data.length && (
          <Element style={{ color: '#9C9C9C' }}>
            <Translate value="common.NO_DATA" />
          </Element>
        )}
        {!!data.length &&
          newArr.map((item, index) => (
            <ItemLink
              item={item}
              key={index}
              typeUserId={userType.userTypeId}
            />
          ))}
      </div>
    </div>
  )
}
